// Copyright (C) 2025 Skylark Drones

export function getBatteryIcon(batteryPercent, isCharging) {
  let suffix = 'mdi-battery'

  if (isCharging) {
    suffix += '-charging'
  }

  if (!batteryPercent) {
    suffix += '-outline'
  } else if (batteryPercent === 100) {
    suffix += ''
  } else if (batteryPercent >= 90) {
    suffix += '-90'
  } else if (batteryPercent >= 80) {
    suffix += '-80'
  } else if (batteryPercent >= 70) {
    suffix += '-70'
  } else if (batteryPercent >= 60) {
    suffix += '-60'
  } else if (batteryPercent >= 50) {
    suffix += '-50'
  } else if (batteryPercent >= 40) {
    suffix += '-40'
  } else if (batteryPercent >= 30) {
    suffix += '-30'
  } else if (batteryPercent >= 15) {
    suffix += '-20'
  } else {
    suffix += '-10'
  }

  return suffix
}

export function getBatteryIconColor(batteryPercent, isCharging) {
  if (isCharging) return 'success'

  if (batteryPercent > 30) {
    return 'success'
  } else if (batteryPercent > 15) {
    return 'amber'
  } else {
    return 'error'
  }
}
